"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOauthApi = void 0;
var _react = require("@reduxjs/toolkit/query/react");
var _objects = require("../utilities/objects");
var _strings = require("../utilities/strings");
const createOauthApi = _ref => {
  let {
    baseUrl,
    slice,
    tokenName
  } = _ref;
  return (0, _react.createApi)({
    reducerPath: 'oauthApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl,
      credentials: 'include',
      method: 'POST',
      prepareHeaders: (headers, _ref2) => {
        var _getState$slice;
        let {
          getState
        } = _ref2;
        const token = (_getState$slice = getState()[slice]) === null || _getState$slice === void 0 ? void 0 : _getState$slice[tokenName];
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      }
    }),
    endpoints: builder => ({
      authorize: builder.mutation({
        query: body => ({
          body,
          url: '/authorize'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getAccessToken: builder.mutation({
        query: body => ({
          body: (0, _strings.objectToBodyString)(body),
          url: '/token'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      login: builder.mutation({
        query: body => ({
          body: (0, _objects.toFormUrlEncoded)(body),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          url: '/login'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      logout: builder.mutation({
        query: body => ({
          body,
          url: '/token/revoke'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      })
    })
  });
};
exports.createOauthApi = createOauthApi;